"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LessonsApi = exports.CoursesAPIs = exports.AwsAPIs = exports.TeamAPIs = exports.AssessmentsAPIs = exports.ChallengesAPIs = exports.LeaderboardAPIs = void 0;
var leaderboardApi_1 = require("./leaderboardApi");
Object.defineProperty(exports, "LeaderboardAPIs", { enumerable: true, get: function () { return __importDefault(leaderboardApi_1).default; } });
var challengesApi_1 = require("./challengesApi");
Object.defineProperty(exports, "ChallengesAPIs", { enumerable: true, get: function () { return __importDefault(challengesApi_1).default; } });
var assessmentsApi_1 = require("./assessmentsApi");
Object.defineProperty(exports, "AssessmentsAPIs", { enumerable: true, get: function () { return __importDefault(assessmentsApi_1).default; } });
var teamApi_1 = require("./teamApi");
Object.defineProperty(exports, "TeamAPIs", { enumerable: true, get: function () { return __importDefault(teamApi_1).default; } });
var awsApi_1 = require("./awsApi");
Object.defineProperty(exports, "AwsAPIs", { enumerable: true, get: function () { return __importDefault(awsApi_1).default; } });
var coursesApi_1 = require("./coursesApi");
Object.defineProperty(exports, "CoursesAPIs", { enumerable: true, get: function () { return __importDefault(coursesApi_1).default; } });
var lessonsApi_1 = require("./lessonsApi");
Object.defineProperty(exports, "LessonsApi", { enumerable: true, get: function () { return __importDefault(lessonsApi_1).default; } });
